const translations = {
  "en": {
    "What I'll do for you": "What I'll do for you",
    "What we'll do": "Step by Step plan"
  },
  "zh-tw": {
    "What I'll do for you": "我會為你做的事",
    "What we'll do": "分步計畫"
  }
};

export default translations;
